module.exports = __webpack_public_path__ + "static/media/FR.42c6b1c7.png";